// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__4y7wc","pagination":"Pagination_pagination__PdX05","active":"Pagination_active__ytS8g","break":"Pagination_break__1Bn8z"};